module.exports = __webpack_public_path__ + "static/media/twitter-line.8ef6c7cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/twitter-line.svg
// module id = 1106
// module chunks = 0